'use strict';
var current;
var offset = 200;
var grid = document.querySelector('.product-grid');
const delay = ms => new Promise(res => setTimeout(res, ms));
var totalheight = document.body.scrollHeight;

$(document).ready(function () {
    checkScroll();
});
/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find(
            '.' + $(this)[0].className.replace(/ /g, '.')
        );
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
    };

    // Update DOM elements that do not require special handling
    var selectors = [
        '.grid-header',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.product-no-results',
    ];

    for (var i = 0; i < selectors.length; i++) {
        updateDom($results, selectors[i]);
    }

    var keys = Object.keys(specialHandlers);

    for (var o = 0; o < keys.length; o++) {
        specialHandlers[keys[o]]($results);
    }
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom
        .find('.grid-footer')
        .data('sort-options').options;

    for (var i = 0; i < sortOptions.length; i++) {
        var option = sortOptions[i];

        $('option.' + option.id).val(option.url);
    }
}

/**
 * @param {*} url
 * @returns string
 */
function getListFromQueryObject(url) {
    var parameters = {};

    var parts = (url.split('?')[1] || '').split('&');

    for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var keyValue = part.split('=');

        parameters[keyValue[0]] = keyValue[1]
            ? decodeURIComponent(keyValue[1])
            : null;
    }

    /**
     * @param string
     * @returns string
     */
    function toTitleCase(string) {
        var titled = [];

        if (!string) {
            return string;
        }

        var parts = string.split('-');

        for (var i = 0; i < parts.length; i++) {
            var part = parts[i];

            titled.push(
                part.charAt(0).toUpperCase() + part.substr(1).toLowerCase()
            );
        }

        return titled.join(' ');
    }

    return (
        (parameters.q ? 'Internal Search' : toTitleCase(parameters.cgid)) +
        (parameters.prefv1 ? '|' + parameters.prefv1 : '') +
        (parameters.srule ? '|' + toTitleCase(parameters.srule) : '')
    );
}
async function checkScroll() {
    current = window.scrollY;
    let gridHeight = grid.getBoundingClientRect().height;
    totalheight = document.body.scrollHeight;
    
    if (current >= gridHeight - offset && current <= totalheight - 1100) {
        showMore();
        await delay(2000);
        $.spinner().stop();
        grid = document.querySelector('.product-grid');
    }
    window.requestAnimationFrame(checkScroll);
}

function showMore() {
    var showMore = document.querySelector('.show-more-url');

    if (showMore) {
        var showMoreUrl = showMore.getAttribute('data-url');
        if (showMoreUrl != '') {
            $.spinner().start();
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                    var list = getListFromQueryObject(showMoreUrl);
                    dataLayerHandler.initOnClickWatcher(list);
                    dataLayerHandler.collectAndPushImpressions(list);
                    $('body').trigger('search:refined');
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        }
    }
}

module.exports = {

    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.row')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.tab-pane.active')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.container.search-results')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on(
            'click',
            '.refinement-bar button.close, .modal-background',
            function () {
                $('.refinement-bar, .modal-background').hide();
                $('.refinement-bar').siblings().attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.row')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.tab-pane.active')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.container.search-results')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.btn.filter-results').focus();
            }
        );
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.row')
                .siblings()
                .attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.tab-pane.active')
                .siblings()
                .attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.container.search-results')
                .siblings()
                .attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            var value = this.value;

            $.spinner().start();
            $(this).trigger('search:sort', value);
            $.ajax({
                url: value,
                data: { selectedUrl: value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $.spinner().stop();

                    var list = getListFromQueryObject(value);

                    dataLayerHandler.initOnClickWatcher(list);
                    dataLayerHandler.collectAndPushImpressions(list);

                    $('body').trigger('search:refined');
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');

            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();

                    var list = getListFromQueryObject(showMoreUrl);

                    dataLayerHandler.initOnClickWatcher(list);
                    dataLayerHandler.collectAndPushImpressions(list);

                    $('body').trigger('search:refined');
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                var href = $(this).data('href');

                $.spinner().start();
                $(this).trigger('search:filter', e);
                $.ajax({
                    url: href,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: href,
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();

                        var list = getListFromQueryObject(href);

                        dataLayerHandler.initOnClickWatcher(list);
                        dataLayerHandler.collectAndPushImpressions(list);

                        $('body').trigger('search:refined');
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                });
            }
        );
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },
};
